document.addEventListener('focusin', handleFocus);
document.addEventListener('focusout', handleBlur);

function handleFocus(event) {
  let focusedElement = event.target;
  let { bgColor, foundOn } = getEffectiveBackground(focusedElement);
  let bgLuminance = getLuminance(bgColor);

  let focusIndicator = getComputedColor(focusedElement, '--focused-base-outline');
  let contrast = contrastRatio(focusIndicator, bgColor);

  if (contrast < 3) {
    let blackContrast = contrastRatio('rgb(0,0,0)', bgColor);
    let whiteContrast = contrastRatio('rgb(255,255,255)', bgColor);
    let bestColor = blackContrast >= 3 ? 'black' : 'white';

    if (bestColor === 'white') {
      focusedElement.classList.add('focus-white');
      focusedElement.classList.remove('focus-black');
    } else {
      focusedElement.classList.add('focus-black');
      focusedElement.classList.remove('focus-white');
    }
  }
}

function handleBlur(event) {
  let focusedElement = event.target;
  focusedElement.classList.remove('focus-white', 'focus-black');
}

function getEffectiveBackground(element) {
  let blendedColor = 'rgb(255, 255, 255)'; // Default to white
  let foundOnElement = document.documentElement;

  // Start traversing up the DOM, skipping the focused element itself
  while (element && element !== document.documentElement) {
    element = element.parentElement; // Skip the focused element itself

    let bgColor = getComputedColor(element, 'background-color');
    let bgImage = getComputedColor(element, 'background');

    // If we find an image or gradient, stop here and return the background color
    if (bgImage.includes('url') || bgImage.includes('gradient')) {
      return { bgColor, foundOn: element };
    }

    // If we find a solid non-transparent background color, return it
    if (bgColor && !isTransparent(bgColor)) {
      foundOnElement = element;
      return { bgColor, foundOn: element };
    }
  }

  return { bgColor: blendedColor, foundOn: foundOnElement };
}

function getComputedColor(element, property) {
  return getComputedStyle(element).getPropertyValue(property).trim();
}

function blendColors(foreground, background, alpha) {
  let fg = foreground.match(/\d+/g).map(Number);
  let bg = background.match(/\d+/g).map(Number);

  let r = Math.round(fg[0] * alpha + bg[0] * (1 - alpha));
  let g = Math.round(fg[1] * alpha + bg[1] * (1 - alpha));
  let b = Math.round(fg[2] * alpha + bg[2] * (1 - alpha));

  return `rgb(${r},${g},${b})`;
}

function getLuminance(color) {
  let rgb = color
    .match(/\d+/g)
    .map(Number)
    .map((c) => {
      let cNorm = c / 255;
      return cNorm <= 0.03928 ? cNorm / 12.92 : Math.pow((cNorm + 0.055) / 1.055, 2.4);
    });

  return 0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2];
}

function contrastRatio(fgColor, bgColor) {
  let fgLuminance = getLuminance(fgColor);
  let bgLuminance = getLuminance(bgColor);

  let contrast = (Math.max(fgLuminance, bgLuminance) + 0.05) / (Math.min(fgLuminance, bgLuminance) + 0.05);
  return parseFloat(contrast.toFixed(2));
}

function isTransparent(bgColor) {
  // Check if the color is "transparent" or has alpha = 0
  return bgColor === 'transparent' || (bgColor.startsWith('rgba') && bgColor.includes(', 0)'));
}
